// 連続受賞年数 -> 24年連続受賞
export const JUSYOU_REKI = 24;

// 創業
export const SOGYOU = 35;
